/* global ga */
import Hammer from 'hammerjs'
import { getDevice, sendAnalyticsEvent, isRetina, removeQuoteFormByDevice, requireCountryCode, trackProductImagePageview } from '../helpers/util'
import { SIZE_DESKTOP, SIZE_TABLET } from '../helpers/constants'

const Direction = {
  LEFT: 'left',
  RIGHT: 'right'
}

let device = getDevice()

var Gallery = {
  images: [],
  loadedImages: [],
  photographers: [],
  currentIndex: 0,
  initialIndex: 0,
  navigationCount: 1,
  prevIndex: 0,
  nextIndex: 0,
  path: null,
  facebookUrl: 'https://www.facebook.com/sharer.php?u=',
  myAd: false,
  pinitUrl: 'https://pinterest.com/pin/create/button/?url=',
  siteUrl: null,
  pageTitle: null,
  pushstateLinks: [],
  eventState: null,
  currentImage: {},
  timer: null,
  projectImage: null, // prev/next gallery link
  eventCount: 0,
  eventCountRight: 0,
  eventCountLeft: 0,
  direction: Direction.RIGHT,
  fromNavigationWidget: (document.location.search.indexOf('ad_name=navigation') > 0)
};

var GalleryUI = {
  margin: 4,
  infoWidth: 376,
  infoFooterHeight: 0,
  zoomActivated: false
};

// manipulating browser history
function initHistory() {
  if (history.pushState) {
    window.addEventListener('popstate', function (e) {
      Gallery.eventState = e.state;
      updateImageByPopState(e.state == null ? Gallery.initialIndex : e.state);
    });
  }
}

function updateImageByPopState(index) {
  unsetPreviousImage();
  Gallery.currentIndex = index;
  setCurrentImage();
  trackingPageview();
}

function setCurrentImage(doPushState) {
  if (typeof (doPushState) === 'undefined') { doPushState = true; }

  Gallery.currentImage = Gallery.images[Gallery.currentIndex];
  Gallery.prevImage = Gallery.images[Gallery.currentIndex - 1];
  Gallery.nextImage = Gallery.images[Gallery.currentIndex + 1];
  document.getElementById('gallery-items').dataset.id = Gallery.currentImage.link

  $(document.getElementById('mobile-original-size-image'))
    .attr('href', Gallery.currentImage.url_large)
    .attr('target', '_blank');
  $(document.getElementById('original-size-image'))
    .attr('href', Gallery.currentImage.url_large)
    .attr('target', '_blank');
  $(document.getElementById(Gallery.currentImage.link))
    .addClass('active-image')
    .parents('.js-gal-figure')
    .removeClass('afd-hide');
  $(document.getElementById('gal-container'))
    .find('.js-gal-current')
    .html(Gallery.currentIndex + 1);

  $(document.getElementById('gal-container'))
    .find('.js-gal-figcaption')
    .html(Gallery.currentImage.caption)
    .attr('title', Gallery.currentImage.caption);

  if (Gallery.currentIndex > 0) {
    $(document.getElementById(Gallery.prevImage.link))
      .addClass('js-gal-mob-img-onview');
  }
  if (Gallery.currentIndex < Gallery.images.length - 1) {
    $(document.getElementById(Gallery.nextImage.link))
      .addClass('js-gal-mob-img-onview');
  }
  $(document.getElementById(Gallery.currentImage.link))
    .addClass('js-gal-mob-img-onview');

  toggleMediaPlan();
  setPreviousPath();
  setNextPath();

  updatePageData();
  trackingCustomvar();
  updateSocialButtons();
  trackProductImagePageview(Gallery.currentImage.link);
  $(window).on('resize orientationchange', function () {
    sliderPosition();
  });
  sliderPosition();
  if (Gallery.currentIndex !== Gallery.initialIndex) { preloadImages(); }
}

function currentImageIndex() {
  $(document.getElementById('gal-container')).find('.js-gal-length').html('/ ' + Gallery.images.length);
}

// UI FUNCTIONS

function gallerySizes() {
  var height = 'innerHeight' in window
    ? window.innerHeight
    : document.documentElement.offsetHeight;
  var width = $(window).width();
  var galHeight = height;
  var galWidth = width - GalleryUI.infoWidth;

  var galImg = $(document.getElementById('gal-img-container')).find('.js-gal-img');
  var galFigure = $(document.getElementById('gal-img-container')).find('.js-gal-figure');
  var galSrollContainer = $(document.getElementById('gal-scrollbox'));
  var galImgContainer = $(document.getElementById('gal-img-container'));

  galImg.css({
    'max-height': galHeight - (GalleryUI.margin * 2),
    'max-width': galWidth
  });
  galImgContainer.css({
    'height': galHeight,
    'line-height': galHeight + 'px',
    'max-width': galWidth
  });
  galSrollContainer.css({
    'height': galHeight - GalleryUI.infoFooterHeight
  });

  galImg.css({
    'max-height': galHeight - (GalleryUI.margin * 2),
    'max-width': galWidth
  });
  galImgContainer.css({
    'height': galHeight,
    'line-height': galHeight + 'px',
    'max-width': galWidth
  });
  galFigure.css({
    'width': galWidth
  })
}

function mouseOut() {
  $(document.getElementById('gal-img-container')).removeClass('js-gal-ui-active');
}

function mouseOver() {
  $(document.getElementById('gal-img-container')).addClass('js-gal-ui-active');
}

function galleryUiActive() {
  document.getElementById('gal-img-container').onmousemove = function () {
    clearTimeout(Gallery.timer);
    Gallery.timer = setTimeout(mouseOut, 3700);
    mouseOver();
    return false;
  };

  document.getElementById('gal-img-container').onmouseleave = function () {
    clearTimeout(Gallery.timer);
    Gallery.timer = setTimeout(mouseOut, 50);
    return false;
  };
}

function zoomMouseMove() {
  if (device !== SIZE_DESKTOP) return
  document.getElementById('gal-img-container').onmousemove = function (e) {
    var $currentImg = $(document.getElementById(Gallery.currentImage.link));
    var halfc = (($(window).width() - GalleryUI.infoWidth) / 2);
    var halfi = $currentImg.width() / 2;
    var xpos = e.pageX - (halfc - halfi);
    var ypos = e.pageY;

    $currentImg.css({ 'transform-origin': xpos + 'px ' + (ypos + 'px') });
  }
}

function toggleZoom() {
  if (GalleryUI.zoomActivated === false) {
    zoomMouseMove();
    GalleryUI.zoomActivated = true;
  } else {
    galleryUiActive();
    GalleryUI.zoomActivated = false;
  }
}

function activateZoom() {
  if (device !== SIZE_DESKTOP) return;

  $('.js-btn-zoom').click(function (e) {
    e.preventDefault();
    $(document.getElementById(Gallery.currentImage.link)).toggleClass('js-gal-img-zoom-active');
    $(document.getElementById('gal-img-container')).toggleClass('js-gal-zoom-active');
    toggleZoom();
    trackZoomInGA();
  });
}

function turnOffZoom() {
  if (GalleryUI.zoomActivated && device === SIZE_DESKTOP) {
    $(document.getElementById(Gallery.currentImage.link)).removeClass('js-gal-img-zoom-active');
    $(document.getElementById('gal-img-container')).removeClass('js-gal-zoom-active');
    toggleZoom();
  }
}

function clickCloseZoom() {
  $('.js-gal-figure').click(function (e) {
    turnOffZoom();
  });
}

function trackZoomInGA() {
  if (GalleryUI.zoomActivated) {
    ga('send', 'event', 'gallery_zoom', 'click_on_zoom_button');
  }
}

function toggleMediaPlan() {
  if (Gallery.currentImage.type === 'MediaPlan') {
    $(document.getElementById('gal-container')).addClass('media-plan');
  } else {
    $(document.getElementById('gal-container')).removeClass('media-plan');
  }
}

function sliderPosition() {
  $(document.getElementById('gallery-items')).addClass('js-gal-slide-animate');
  var sliderPos = -Gallery.currentIndex * $(window).width();
  moveSlides(sliderPos);
}

function moveSlides(sliderMove) {
  $(document.getElementById('gallery-items')).css('transform', 'translate3d(' + sliderMove + 'px,0,0)');
}

function touchGestures() {
  var myElement = document.getElementById('gallery-items');
  var mc = new Hammer(myElement);

  mc.on('tap release dragleft dragright swipeleft swiperight', function (ev) {
    ev.preventDefault();

    switch (ev.type) {
      case 'dragleft':
      case 'dragright':

        var slideOffset = -(Gallery.currentIndex * $(window).width()) + ev.deltaX;

        $(document.getElementById('gal-img-container')).find('.js-gal-loader').addClass('afd-hide');
        $(document.getElementById('gallery-items')).removeClass('js-gal-slide-animate');
        moveSlides(slideOffset);
        break;

      case 'release':
        if (Math.abs(ev.deltaX) > $(window).width() / 3) {
          if (ev.direction === Direction.RIGHT) {
            previousImage();
          } else {
            nextImage();
          }
        } else {
          sliderPosition();
        }
        break;

      case 'swipeleft':
        nextImage();
        break;
      case 'swiperight':
        previousImage();
        break;
      case 'tap':
        $('body').toggleClass('js-gal-mob-info-hidden');
        break;
    }
  });
}

function previousImage() {
  if (Gallery.currentIndex > 0) {
    unsetPreviousImage();
    Gallery.currentIndex -= 1;
    Gallery.navigationCount += 1;
    pushstateOnNavigation();
    setCurrentImage();
    trackingPageview();
  }

  Gallery.direction = Direction.LEFT;
  projectNavigation();
}

function nextImage() {
  if (Gallery.currentIndex < Gallery.images.length - 1) {
    unsetPreviousImage();
    Gallery.currentIndex += 1;
    Gallery.navigationCount += 1;
    pushstateOnNavigation();
    setCurrentImage();
    trackingPageview();
  }

  Gallery.direction = Direction.RIGHT;
  projectNavigation();
}

function setPreviousPath() {
  if (Gallery.currentIndex > 0) {
    var imageId = Gallery.images[Gallery.currentIndex - 1].link;
    $(document.getElementById('prev-image'))
      .attr('href', galleryImagePath(imageId, Direction.LEFT))
  }
}

function setNextPath() {
  if (Gallery.currentIndex < Gallery.images.length - 1) {
    var imageId = Gallery.images[Gallery.currentIndex + 1].link;
    $(document.getElementById('next-image'))
      .attr('href', galleryImagePath(imageId, Direction.RIGHT))
  }
}

function unsetPreviousImage() {
  $(document.getElementById(Gallery.currentImage.link)).removeClass('active-image').parents('.js-gal-figure').addClass('afd-hide');
  if (Gallery.currentIndex > 0) {
    $(document.getElementById(Gallery.prevImage.link)).removeClass('js-gal-mob-img-onview');
  }
  if (Gallery.currentIndex < Gallery.images.length - 1) {
    $(document.getElementById(Gallery.nextImage.link)).removeClass('js-gal-mob-img-onview');
  }
  $(document.getElementById(Gallery.currentImage.link)).removeClass('js-gal-mob-img-onview');
}

function ADParams(direction) {
  if (isPreviewGallery()) {
    return '';
  }

  if (direction === Direction.RIGHT) {
    return '?ad_source=neufert&ad_medium=gallery&ad_name=next_image';
  } else {
    return '?ad_source=neufert&ad_medium=gallery&ad_name=previous_image';
  }
}

function isPreviewGallery() {
  return Gallery.path && Gallery.path.indexOf('/preview_product/') >= 0;
}

function galleryImagePath(imageId, direction) {
  var pathParts = Gallery.path.split('?');
  var basePath = pathParts[0];
  var query = pathParts[1];
  var suffix = ADParams(direction || Gallery.direction);
  var queryString = query ? '?' + query : '';

  if (suffix.length > 0) {
    queryString += queryString.length > 0 ? '&' + suffix.slice(1) : suffix;
  }

  return basePath + '/' + imageId + queryString;
}

function preloadImages() {
  // console.log ("Preload! Current index " + Gallery.currentIndex);
  // preload 2 images forward
  if (Gallery.currentIndex <= Gallery.images.length) {
    for (var i = Gallery.currentIndex; i < Gallery.currentIndex + 3 && i < Gallery.images.length; i++) {
      // console.log ("Preloading forward index " + i);
      preloadImagesByIndex(i);
    }
  }

  // preload 1 image backward
  if (Gallery.currentIndex >= 0) {
    for (let i = Gallery.currentIndex - 1; i > Gallery.currentIndex - 2 && i >= 0; i--) {
      preloadImagesByIndex(i);
    }
  }
}

// preload images
function preloadImagesByIndex(index) {
  if (Gallery.loadedImages.indexOf(index) >= 0) {
    return false;
  }

  var chooseImageResolution = isRetina() ? 1 : 0
  var imageUrl = '';
  var imageId = Gallery.images[index].link;

  switch (device) {
    case SIZE_DESKTOP:
      imageUrl = Gallery.images[index].url.desktop[chooseImageResolution];
      break;
    case SIZE_TABLET:
      imageUrl = Gallery.images[index].url.tablet[chooseImageResolution];
      break;
    default:
      imageUrl = Gallery.images[index].url.mobile[chooseImageResolution];
  }

  document.getElementById(imageId).setAttribute('src', imageUrl);

  // set current image if index === CurrentIndex
  if (Gallery.currentIndex === index) {
    setCurrentImage(false);
  }
  Gallery.loadedImages.push(index);
}

function trackingPageview() {
  // track pageview
  ga('send', 'pageview', window.location.pathname);
  window.adInsights.p();
}

function trackingCustomvar() {
  var type = $(document.getElementById('gallery-items')).data('ad-type');
  ga('set', 'dimension1', type)
}

function updatePageData() {
  document.title = document.title.replace(/- (\d+)/, '- ' + (Gallery.currentIndex + 1));
  Gallery.pageTitle = document.title
}

function updateSocialButtons() {
  var saveComponents = document.querySelectorAll(".js-save-button");
  if (!saveComponents.length) {
    console.error("Couldn't find save component");
    return;
  }
  var dropdownComponents = document.querySelectorAll('.js-gallery-dropdown')
  var chooseImageResolution = isRetina() ? 1 : 0
  var locationUrl = window.location.href;
  var pageImage = Gallery.currentImage.url.desktop[chooseImageResolution];

  saveComponents.forEach((saveComponent) => {
    saveComponent.url = locationUrl;
    saveComponent.pageTitle = Gallery.pageTitle;
    saveComponent.pageImage = pageImage;
  })

  dropdownComponents.forEach((dropdownComponent) => {
    dropdownComponent.url = locationUrl;
    dropdownComponent.pageTitle = Gallery.pageTitle;
    dropdownComponent.pageImage = pageImage;
    dropdownComponent.setAttribute('url', locationUrl);
    dropdownComponent.setAttribute('page-title', Gallery.pageTitle);
    dropdownComponent.setAttribute('page-image', pageImage);
  })

  document.querySelectorAll('.js-image-interaction-tracking').forEach(component => {
    component.dataset.imageInteractionToken = Gallery.currentImage.link
  })
}

function pushstateOnNavigation() {
  if (history.pushState) {
    // allowing pushstate
    if (Gallery.eventState === undefined || Gallery.eventState !== Gallery.currentIndex) {
      window.history.pushState(Gallery.currentIndex, '', galleryImagePath(Gallery.images[Gallery.currentIndex].link, Gallery.direction));
    }
    Gallery.pushstateLinks = []; // cleaning pushstate fake array
  }
}

function refreshEventCount() {
  if (Gallery.direction === Direction.RIGHT) {
    Gallery.eventCountRight += 1;
    Gallery.eventCountLeft = 0;
  } else {
    Gallery.eventCountRight = 0;
    Gallery.eventCountLeft += 1;
  }
}

function projectNavigation() {
  // This function has to consider different cases:
  // 1. First gallery
  // 2. Galleries with 1 image
  // 3. Galleries with more than 1 image
  // 4. Hover on the widget
  // 5. Display of the widget when navigate with arrows

  var $previousGallery = $(document.getElementById('previous-gallery'));
  var $nextGallery = $(document.getElementById('next-gallery'));
  var $prevImage = $(document.getElementById('prev-image'));
  var $nextImage = $(document.getElementById('next-image'));

  if (Gallery.images.length === 1) {
    $previousGallery.addClass('afd-gal-nav--singlepic');
    $prevImage.addClass('afd-image-nav--hide');
    $nextImage.addClass('afd-image-nav--hide');

    refreshEventCount();

    if (Gallery.direction === Direction.RIGHT) {
      $nextGallery.addClass('afd-gal-nav--displayed');
      $previousGallery.removeClass('afd-gal-nav--displayed');
      Gallery.projectImage = $nextGallery;
    } else {
      $previousGallery.addClass('afd-gal-nav--displayed');
      $nextGallery.removeClass('afd-gal-nav--displayed');
      Gallery.projectImage = $previousGallery;
    }
  } else {
    switch (Gallery.currentIndex) {
      case 0:
        $previousGallery.addClass('afd-gal-nav--displayed');
        $nextGallery.removeClass('afd-gal-nav--displayed');
        $nextImage.removeClass('afd-image-nav--hide');
        $prevImage.addClass('afd-image-nav--hide');
        Gallery.projectImage = $previousGallery;
        refreshEventCount();
        break;

      case (Gallery.images.length - 1):
        $nextGallery.addClass('afd-gal-nav--displayed');
        $previousGallery.removeClass('afd-gal-nav--displayed');
        $nextImage.addClass('afd-image-nav--hide');
        $prevImage.removeClass('afd-image-nav--hide');
        Gallery.projectImage = $nextGallery;
        refreshEventCount();
        break;

      default:
        $previousGallery.removeClass('afd-gal-nav--displayed');
        $nextGallery.removeClass('afd-gal-nav--displayed');
        $prevImage.removeClass('afd-image-nav--hide');
        $nextImage.removeClass('afd-image-nav--hide');
        Gallery.eventCountRight = 0;
        Gallery.eventCountLeft = 0;
        break;
    }
  }

  if (Gallery.direction === Direction.RIGHT) {
    Gallery.eventCount = Gallery.eventCountRight;
  } else {
    Gallery.eventCount = Gallery.eventCountLeft;
  }

  switch (Gallery.eventCount) {
    case 2:
      // show previous/next project
      $(Gallery.projectImage).addClass('js-show-gal-nav');

      break;
    case 3:
      // redirect to next project
      window.location.href = $(Gallery.projectImage).find('a[href]').attr('href');
      break;
    default:
      $(Gallery.projectImage).removeClass('js-show-gal-nav');
  }
}

function initMobileModalQuote() {
  if (device === SIZE_DESKTOP) return;

  const btn = document.getElementById('gallery-quote')
  const { countries = '[]' } = btn.dataset
  const parsedCountries = JSON.parse(countries)
  const currentCountry = parsedCountries.find(country => AFD.countryCode === country[1])
  const isUserInBusinessCountries = !!currentCountry

  if (!isUserInBusinessCountries) {
    btn.remove()
    return
  }

  btn && btn.addEventListener('click', e => {
    e.preventDefault();
    AFD.modals.open('#gallery-info-request');
    const eventArgs = {
      type: 'event',
      category: 'quote-cta-on-mobile',
      action: 'click',
      label: 'Send message gallery-contact'
    }

    sendAnalyticsEvent(eventArgs);
  })
}

export function initGallery() {
  removeQuoteFormByDevice('.js-quote-form-container')
  const $gallery = $(document.getElementById('gallery-items'))
  if (!$gallery.length) return;

  const $nextImage = $(document.getElementById('next-image'));
  const $prevImage = $(document.getElementById('prev-image'));
  Gallery.images = $gallery.data('images');
  Gallery.photographers = $gallery.data('photographers');
  Gallery.currentIndex = $gallery.data('index');
  Gallery.path = $gallery.data('path');
  Gallery.siteUrl = $gallery.data('site-url');
  Gallery.initialIndex = Gallery.currentIndex;

  window.initializeMyAD();
  initHistory();
  preloadImages();
  gallerySizes();
  galleryUiActive();
  currentImageIndex();
  activateZoom();
  clickCloseZoom();
  requireCountryCode(initMobileModalQuote)

  $prevImage.on('click', function (e) {
    e.preventDefault();
    turnOffZoom();
    previousImage();
  });

  $nextImage.on('click', function (e) {
    e.preventDefault();
    turnOffZoom();
    nextImage();
  });

  $(document).on('keyup', function (e) {
    if (e.key === 'ArrowRight') {
      turnOffZoom();
      nextImage();
    } else if (e.key === 'ArrowLeft') {
      turnOffZoom();
      previousImage();
    } else if (e.key === 'Escape') {
      document.getElementsByClassName('js-gal-close')[0].click();
    }
  });

  $(document).on('mousedown', '.js-image-nav', function (e) {
    if (e.which === 3 || (e.which === 1 && e.ctrlKey)) {
      $gallery.css('z-index', 4);

      setTimeout(function () {
        $gallery.css('z-index', 1);
      }, 300);
    }
  });

  $(window).on('resize orientationchange', function () {
    gallerySizes();
    device = getDevice()
  });
  touchGestures();

  if (window.devicePixelRatio > 1) {
    document.querySelector('html').className += ' retina';
  }
}
